module.exports = "/_next/static/images/DashboardUnderstand-5e7eea34598247b9abcca2e9518855e1.webp";